import React, { useState } from 'react';
import Layout from '../components/Layout';

import Sidebar from '../components/Sidebar';
import Classes from './index.module.css';

import arrow_right from '../assets/images/arrow_right.png';
import arrow_left from '../assets/images/arrow_left.png';
import { Link } from 'gatsby';
import satan_blocker from '../assets/images/satan-blocker.png';

const Love = () => {
  const [counter, setCounter] = useState(100);
  //increase counter
  const increase = () => {
    setCounter(count => count + 1);
  };

  //decrease counter
  const decrease = () => {
    setCounter(count => count - 1);
  };

  //reset counter
  const reset = () => {
    setCounter(100);
  };
  return (
    <Layout>
      <Sidebar showTabs="false" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="top"
      >
        <ul>
          <li>
            <h2>Sins</h2>
          </li>

          <p />
          <h3>References</h3>
          <ul>
            <li>
              <a href="https://youtu.be/GbgMMPx_nnk" target="blank">
                Repentance
              </a>
            </li>
            <li>
              <a href="https://youtu.be/TP-X1ME9Ivs" target="blank">
                Practicing Repentance 1
              </a>
            </li>
            <li>
              <a href="https://youtu.be/XhrvEYD8BZY" target="blank">
                Practicing Repentance 2
              </a>
            </li>
            <li>
              <a href="https://youtu.be/GbgMMPx_nnk" target="blank">
                Erasing Our Sins - Deeds to erase Sins
              </a>
            </li>
            <li>
              <a href="https://youtu.be/vrMqWBvcdT4" target="blank">
                Erasing Our Sins - Times of Multiplication
              </a>
            </li>
            <li>
              <a href="https://youtu.be/Tyas5fi3TBE" target="blank">
                Erasing Our Sins - Calamities and Trials
              </a>
            </li>
            <li>
              <a href="https://youtu.be/Jh2koRgGDGQ" target="blank">
                Asking For Forgiveness
              </a>
            </li>
            <li>
              <a href="https://myislam.net/static/repent.pdf">
                Repentane: Written PDF file to download
              </a>
            </li>
          </ul>
        </ul>
      </section>
      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="references"
      >
        <p />
        <h3>References</h3>
        <ul>
          <li>
            <a href="https://youtu.be/mlXxfExscOQ">
              خفف همك وغمك وحزنك وكربك بهذه الطرق الروحية"مواجهة الاكتئاب وعدم
              الرغبة في الحياة{' '}
            </a>
          </li>
        </ul>
      </section>
    </Layout>
  );
};

export default Love;
